export const PROFESSION_OPTIONS = [
  { label: "Chartered Accountant (CA)", value: "Chartered Accountant (CA)" },
  { label: "Company Secretary (CS)", value: "Company Secretary (CS)" },
  {
    label: "Cost & Management Accountant (CMA)",
    value: "Cost & Management Accountant (CMA)",
  },
  {
    label: "Chartered Financial Analyst (CFA)",
    value: "Chartered Financial Analyst (CFA)",
  },
  { label: "BCom", value: "BCom" },
  { label: "MCom", value: "MCom" },
  { label: "BBA", value: "BBA" },
  { label: "MBA", value: "MBA" },
  { label: "BTech", value: "BTech" },
  { label: "MTech", value: "MTech" },
  { label: "BE", value: "BE" },
  { label: "ME", value: "ME" },
  { label: "BCA", value: "BCA" },
  { label: "MCA", value: "MCA" },
  { label: "Software Engineer", value: "Software Engineer" },
  { label: "Full Stack Developer", value: "Full Stack Developer" },
  { label: "Data Scientist", value: "Data Scientist" },
  { label: "AI / ML Engineer", value: "AI / ML Engineer" },
  { label: "Cyber Security Specialist", value: "Cyber Security Specialist" },
  { label: "Civil Engineer", value: "Civil Engineer" },
  { label: "Mechanical Engineer", value: "Mechanical Engineer" },
  { label: "Electrical Engineer", value: "Electrical Engineer" },
  { label: "Electronics Engineer", value: "Electronics Engineer" },
  { label: "Biotechnology", value: "Biotechnology" },
  { label: "Biotech Engineer", value: "Biotech Engineer" },
  { label: "Scientist", value: "Scientist" },
  { label: "Researcher", value: "Researcher" },
  { label: "Finance", value: "Finance" },
  { label: "Finance Analyst", value: "Finance Analyst" },
  { label: "Wealth Manager", value: "Wealth Manager" },
  { label: "Mutual Fund Advisor", value: "Mutual Fund Advisor" },
  { label: "Stock Market Investor", value: "Stock Market Investor" },
  { label: "Stock Market Trader", value: "Stock Market Trader" },
  { label: "Banker", value: "Banker" },
  { label: "Insurance Advisor", value: "Insurance Advisor" },
  { label: "Entrepreneur", value: "Entrepreneur" },
  { label: "Business Owner", value: "Business Owner" },
  { label: "Startup Founder", value: "Startup Founder" },
  { label: "Consultant", value: "Consultant" },
  { label: "Space Scientist", value: "Space Scientist" },
  { label: "ISRO Scientist", value: "ISRO Scientist" },
  { label: "DRDO Scientist", value: "DRDO Scientist" },
  { label: "Astronaut", value: "Astronaut" },
  { label: "Doctor - MBBS", value: "Doctor - MBBS" },
  { label: "Doctor - MD", value: "Doctor - MD" },
  { label: "Doctor - BHMS", value: "Doctor - BHMS" },
  { label: "Doctor - BDS", value: "Doctor - BDS" },
  { label: "Doctor - MDS", value: "Doctor - MDS" },
  { label: "Doctor - BAMS", value: "Doctor - BAMS" },
  { label: "Nurse", value: "Nurse" },
  { label: "Pharmacist", value: "Pharmacist" },
  { label: "Physiotherapist", value: "Physiotherapist" },
  { label: "Advocate", value: "Advocate" },
  { label: "Lawyer", value: "Lawyer" },
  { label: "Judge", value: "Judge" },
  { label: "Legal Advisor", value: "Legal Advisor" },
  { label: "IAS", value: "IAS" },
  { label: "IPS", value: "IPS" },
  { label: "IFS", value: "IFS" },
  { label: "IRS", value: "IRS" },
  { label: "UPSC Aspirant", value: "UPSC Aspirant" },
  { label: "Government Officer", value: "Government Officer" },
  { label: "Professor", value: "Professor" },
  { label: "Lecturer", value: "Lecturer" },
  { label: "Teacher", value: "Teacher" },
  { label: "Principal", value: "Principal" },
  { label: "Architect", value: "Architect" },
  { label: "Interior Designer", value: "Interior Designer" },
  { label: "Journalist", value: "Journalist" },
  { label: "Writer", value: "Writer" },
  { label: "Artist", value: "Artist" },
  { label: "Photographer", value: "Photographer" },
  { label: "Filmmaker", value: "Filmmaker" },
  { label: "Other", value: "__other__" },
];

